<template>
  <a-modal
    :visible="visible"
    width="630px"
    :title="`Detalles del horario de ${botTypeName} - ${chatbot.name}`"
    :keyboard="false"
    centered
    @cancel="handleClose"
  >
    <section class="section">
      <h4>Días y horarios de ejecución</h4>

      <template v-if="groupedSchedule.length > 0">
        <div class="day" v-for="schedule in groupedSchedule" :key="schedule.weekday">
          <p>{{ getDayNameByIndex(schedule.weekday) }}</p>

          <div class="hours">
            <p v-for="hourRange in schedule.items" :key="hourRange.id">
              {{ hourRange.start_hour?.substring(0, 5) }} -
              {{ hourRange.end_hour?.substring(0, 5) }}
            </p>
          </div>
        </div>
      </template>

      <template v-else>
        <p class="info">No tiene un horario configurado</p>
      </template>
    </section>

    <template #footer>
      <a-button @click="handleClose"> Cerrar detalles </a-button>
      <a-button type="primary" @click="handleGoToEdit"> Editar {{ botTypeName }} </a-button>
    </template>
  </a-modal>
</template>

<script>
import { defineComponent, computed } from "vue";
import { useRouter } from "vue-router";

import { transformIndexDays } from "@/app/shared/utils/transform";
import { groupByDay } from "@/app/chatbots/utils/groupByDay";
import { ChatbotStatus } from "@/app/chatbots/utils/enums";

export default defineComponent({
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    chatbot: {
      required: true,
      type: Object,
    },
    ivr: {
      type: Boolean,
      default: false,
    },
    sequence: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const router = useRouter();

    const botTypeName = computed(() => {
      if (props.ivr) return "IVR";
      if (props.sequence) return "secuencia";

      return "chatbot";
    });

    const groupedSchedule = computed(() =>
      groupByDay(props.chatbot.schedules, (schedule) => schedule.weekday)
    );

    const disabled = computed(() => props.chatbot.status === ChatbotStatus.Active);

    const getDayNameByIndex = (idx) => {
      const day = transformIndexDays([idx]);

      return day[0]?.day;
    };

    const handleGoToEdit = () => {
      if (props.ivr) emit("edit");
      else if (props.sequence) emit("edit");
      else router.push(`/chatbots/tree/${props.chatbot.id}`);
    };

    const handleClose = () => {
      emit("close");
    };

    return {
      groupedSchedule,
      disabled,
      getDayNameByIndex,
      handleGoToEdit,
      handleClose,
      botTypeName,
    };
  },
});
</script>

<style lang="sass" scoped>
.section
  color: gray-9

  h4
    margin: 0
    font-size: 14px

.day
  padding: 12px
  display: grid
  grid-template-columns: 80px 1fr
  border-bottom: 1px solid $gray-5

  p
    margin: 0

.info
  margin: 12px
  color: $gray-8
</style>
